(() => {
  angular
    .module('app.components')
    .directive('panelProductCollapsible', ['$sce',
      ($sce) => ({
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
          // icon: '@',
          caption: '@',
          expanded: '@',
          filtered: '@',
        },
        link: (scope, element, attrs) => {
          attrs.$observe('expanded', (value) => {
            if (value === 'true') {
              scope.panelExpanded = true;
            }
          });

          attrs.$observe('filtered', (value) => {
            if (value) {
              scope.filtered = value;
            }
          });
        },
        controller: ['$scope', ($scope) => {
          const panelExpandedState = `panelProduct-${$scope.caption}-expanded`;
          $scope.panelExpanded = sessionStorage.getItem(panelExpandedState);

          // if ($scope.icon) {
          //   $scope.iconPath = `../../assets/img/icons/Logos/${$scope.icon}.svg`;
          // }

          if ($scope.panelExpanded === null) {
            $scope.panelExpanded = true;
          } else {
            $scope.panelExpanded = $scope.panelExpanded === 'true';
          }

          $scope.onPanelToggle = () => {
            $scope.panelExpanded = !$scope.panelExpanded;
            sessionStorage.setItem(panelExpandedState, $scope.panelExpanded);
          }
        }],
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/panels/panel.product.collapsible.template.html'),
      })
    ]);
})();
